export default {
  async deleteByIdStr (api, idStr, callback) {
    await httpKit.post(api, { 'ids': idStr }).then(res => {
      callback(res);
    });
  },
  async deleteByIdAry (api, idAry, callback) {
    let idStr = idAry.join(',');
    this.deleteByIdStr(api,idStr,callback);
  },
  async deleteByObjAry (api, objAry, callback) {
    if (objAry.length > 0) {
      const idAry = [];
      for (let key in objAry) {
        idAry.push(objAry[key].id);
      }
      this.deleteByIdAry(api, idAry, callback);
    }
  }
};
